import React from 'react';
import { BConnectParamsConfigType } from '../../Admin/Params/Types';
import { t } from 'i18next';

const is_default = {
  name: 'is_default',
  label: 'equipmentConfig.isDefaultLabel',
  type: 'checkbox'
};

const intervention_expiry_days = {
  name: 'intervention_expiry_days',
  label: 'equipmentConfig.interventionExpiryDaysLabel',
  type: 'number'
};

const icon = {
  name: 'icon',
  label: 'equipmentConfig.iconLabel',
  type: 'image',
  transform: (value: any) => {
    const startPng = 'data:image/png;base64,';
    const startJpeg = 'data:image/jpeg;base64,';
    if (value && !value.startsWith(startPng) && !value.startsWith(startJpeg)) {
      value = startPng + value;
    }

    if (value) {
      return <img src={value} style={{ width: '50px', height: '50px' }} alt="Preview" />;
    }
  }
};

const families = {
  name: 'families',
  label: "Famille d'équipement",
  type: 'text'
};

const radio_modes = {
  name: 'radio_modes',
  label: 'Mode radio',
  type: 'text'
};

const authorised_contracts = {
  name: 'authorised_contracts',
  label: 'Clients / contrats autorisés',
  type: 'text'
};

const excluded_contracts = {
  name: 'excluded_contracts',
  label: 'Clients / contrats non autorisés',
  type: 'text'
};

const id = {
  name: 'id',
  label: 'equipmentConfig.idLabel',
  type: 'number'
};

const name = {
  name: 'name',
  label: 'equipmentConfig.nameLabel',
  type: 'text'
};

const dataset_code = {
  name: 'dataset_code',
  label: 'equipmentConfig.datasetCodeLabel',
  type: 'text'
};

const dst = {
  name: 'dst',
  label: 'equipmentConfig.dstLabel',
  type: 'checkbox'
};

const time_index = {
  name: 'time_index',
  label: 'equipmentConfig.timeIndexLabel',
  type: 'checkbox'
};

const autoconnect = {
  name: 'autoconnect',
  label: 'equipmentConfig.autoconnectLabel',
  type: 'checkbox'
};

export const formFields = {
  id,
  name,
  families,
  radio_modes,
  authorised_contracts,
  excluded_contracts,
  intervention_expiry_days,
  icon,
  dataset_code,
  dst,
  time_index,
  autoconnect,
  is_default
};

export const equipmentConfig: { [key: string]: BConnectParamsConfigType } = {
  configuration: {
    value: 'configuration',
    label: 'Configuration',
    endpoint: '/api/boi/params/configuration-profiles/',
    extraFields: [
      name,
      families,
      radio_modes,
      dataset_code,
      dst,
      time_index,
      autoconnect,
      authorised_contracts,
      excluded_contracts,
      is_default
    ],
    buttonText: t('equipmentConfig.radioParameter')
  },
  families: {
    value: 'families',
    label: t('equipmentFamilies.title'),
    endpoint: '/api/boi/exocet/families/',
    extraFields: [id, name, intervention_expiry_days, icon],
    buttonText: "une famille d'équipement"
  }
};
